import { button } from '@groovehq/internal-design-system/lib/styles/elements'

export default function TagDropdownCreateButton({ onCreateTag, className }) {
  return (
    <button
      type="button"
      css={button.styles.link}
      onClick={onCreateTag}
      className={className}
    >
      + Create a tag
    </button>
  )
}
